import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sublimeSecurity = defineConnector({
  identifier: "sublimeSecurity",
  name: "Sublime Security",
  tagLine: "Email security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.platform\\.sublime\\.security/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get a Sublime Security API key",
      items: [
        {
          kind: "markdown",
          content:
            "Login to your Sublime Security tenant (https://platform.sublime.security/developer)\n\nSelect the API tab on the left panel\n\nSelect New Key and name it",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Enter your base URL",
      items: [
        {
          kind: "baseUrl",
          label: "Base URL",
          placeholder: "https://na-east-3.platform.sublime.security",
          defaultValue: "https://na-east-3.platform.sublime.security",
          required: true,
          target: { kind: "configuration", field: "baseUrl" },
        },
        {
          kind: "markdown",
          content:
            "You can find this on the API key page. For example: https://na-east-3.platform.sublime.security",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url: `${baseUrl}/v0/rules?limit=1`,
      expectedStatus: [200, 403],
    }),
  },
  publicEnvVars: ({ baseUrl }) => ({
    SUBLIME_SECURITY_URL: baseUrl || "",
  }),
});
